import {
  initDLMAdminReviewValues, DLMAdminReviewSchema,

  initDLMTestResultValues, DLMTestResultSchema,
  initDLMProgramManagerSetupValues, DLMProgramManagerSetupSchema,

  initDLMSubmitDOCValues, DLMSubmitDOCSchema,
  initDLMSubmitROIValues, DLMSubmitROISchema,

  initDLMSelectReviewerValues, DLMSelectReviewerSchema,

  initDLMSetupInspectionValues, DLMSetupInspectionSchema,
  initVerifyDOCValues, DLMVerifyDOCSchema,
  initDLMSubmitInspectionValues, DLMSubmitInspectionSchema,

  initDLMPhaseNoteValues, DLMPhaseNoteSchema,

  initDLMPMRejectROIValues, DLMPMRejectROISchema,
  DLMAdminReview1B3Schema,
  DLMApplicantSignedSchema,
  initDLMApplicantSignedValues,
  DLMTravelNoteSchema,
  initDLMTravelNoteValues,
  initDLMComponentCheckValues, DLMComponentCheckSchema,   
  initDLMQuotationUploadValues, DLMQuotationUploadSchema,

} from '../forms';

import {
  submitDLMPhase_1_1,
  submitDLMPhase_2_1,
  submitDLMPhase_2_2,
  submitDLMPhase_2_3,
  submitDLMPhase_2_4,
  submitDLMPhase_3_1,
  submitDLMPhase_3_2,
  submitDLMPhase_3_3,
  submitDLMPhase_3_4,
  submitDLMPhase_3_5,
  submitDLMPhase_4_1,
  submitDLMPhase_4_2,
  submitDLMPhase_4_3,
  submitDLMPhase_4_4,
  submitDLMPhase_4_5,

  submitDLMPhase_5_1,
  submitDLMPhase_5_2,
  submitDLMPhase_5_4,
  submitDLMPhase_6_1,
  submitDLMPhase_6_2,
  submitDLMPhase_6_4,
} from '../../../../../core/doclabel';

import { cloneDeep } from 'lodash';

import { initBillingDetails } from '../../../../../../components/widgets';

import { ApplicationQuotation } from '../../../../../core/applications';
import { isPopulatedArray } from '../../../../../../components/helpers';

const getUserResponseVars = (appState: string, workflow: string, docModels?: any, siteROIModels?: any, quotations?: Array<ApplicationQuotation> ) => {

  let initValues = null;
  let schema = {};
  let submitFunc = undefined;
  let hasBillingDetails = false;

  switch (appState) {
    case 'Admin Review' :
      initValues = cloneDeep(initDLMAdminReviewValues);
      schema = (workflow === 'Label1b3') ? DLMAdminReview1B3Schema : DLMAdminReviewSchema;      
      submitFunc = submitDLMPhase_1_1;
      break;

    case 'Program Manager Approval':
      initValues = cloneDeep(initDLMPhaseNoteValues);
      schema = DLMPhaseNoteSchema;
      if (['Label5','DOCEdit','DOCSplit','ROIEdit','ROISplit'].includes(workflow)) {
        submitFunc = submitDLMPhase_2_1;
      } else if(['DOC','MandatoryDOC'].includes(workflow)) {
        submitFunc = submitDLMPhase_4_2;
      }
      break;


    case 'Schedule For Sampling':
      if (workflow === 'TriggerTest' || workflow === 'MandatoryDOC1B') {
        initValues = cloneDeep(initDLMSetupInspectionValues);
        schema = DLMSetupInspectionSchema;
        if (workflow === 'TriggerTest') {
          submitFunc = submitDLMPhase_3_1;
        } else if (workflow === 'MandatoryDOC1B') {
          submitFunc = submitDLMPhase_2_1;
        }
        
      }
      break;

    case 'Site Inspection':
      if (workflow === 'SiteInspect' || workflow === 'LabelInspect' || workflow === 'MandatoryDOC') {
        initValues = {
          ...cloneDeep(initDLMSelectReviewerValues),
          ...cloneDeep(initBillingDetails),
        };
        schema = DLMSelectReviewerSchema;
        submitFunc = submitDLMPhase_2_1;
        hasBillingDetails = true;
      } else if (workflow === 'Label1b1' || workflow === 'LabelReplacement') {
        initValues = {
          ...cloneDeep(initDLMSubmitInspectionValues),
          ...cloneDeep(initBillingDetails),
        };
        schema = DLMSubmitInspectionSchema;
        submitFunc = submitDLMPhase_2_1;
        hasBillingDetails = true;
      } else if (workflow === 'Label5' || workflow === 'MandatoryDOC1B') {
        // Phase 5_2
        initValues = {
          ...cloneDeep(initDLMSelectReviewerValues),
          ...cloneDeep(initBillingDetails),
        };;
        schema = DLMSelectReviewerSchema;
        submitFunc = submitDLMPhase_5_2;
        hasBillingDetails = true;
      }
      break;

    // case 'Program Manager Rejected':

    //   if (['DOC','MandatoryDOC'].includes(workflow)) {
    //     initValues = cloneDeep(initDLMProgramManagerSetupValues);
    //     Object.assign(initValues, {appState});
    //     schema = DLMProgramManagerSetupSchema;
    //     submitFunc = submitDLMPhase_4_3;
    //   }
    //   break;
    
    case 'Program Manager Rejected (A)':
      if (workflow === 'Label5') {
        initValues = cloneDeep(initDLMPMRejectROIValues);
        schema = DLMPMRejectROISchema;
        submitFunc = submitDLMPhase_2_2;
      } else if (['DOCEdit','DOCSplit'].includes(workflow)) { 
        initValues = cloneDeep(initDLMProgramManagerSetupValues);
        Object.assign(initValues, {appState});
        schema = DLMProgramManagerSetupSchema;
        submitFunc = submitDLMPhase_2_2;
      } else if (workflow === 'ROIEdit' || workflow === 'ROISplit') {
        initValues = cloneDeep(initDLMPhaseNoteValues);
        schema = DLMPhaseNoteSchema;
        submitFunc = submitDLMPhase_2_2;
      } else if (['DOC','MandatoryDOC'].includes(workflow)) {
        initValues = cloneDeep(initDLMProgramManagerSetupValues);
        Object.assign(initValues, {appState});
        schema = DLMProgramManagerSetupSchema;
        submitFunc = submitDLMPhase_4_3;
      }
      break;

    case 'Program Manager Approved':
      if (['DOC','MandatoryDOC'].includes(workflow)) {
        initValues = cloneDeep(initDLMSubmitDOCValues);
        schema = DLMSubmitDOCSchema;
        submitFunc = submitDLMPhase_5_1;
      } else if (['DOCEdit','DOCSplit'].includes(workflow)) {
        initValues = cloneDeep(initDLMSubmitDOCValues);
        schema = DLMSubmitDOCSchema;
        submitFunc = submitDLMPhase_3_1;
      } else if (workflow === 'Label5' || workflow === 'ROIEdit' || workflow === 'ROISplit') {
        initValues = cloneDeep(initDLMSubmitROIValues);
        schema = DLMSubmitROISchema;
        submitFunc = submitDLMPhase_3_1;
      }
      break;

    case 'Applicant Signed':
      initValues = cloneDeep(initDLMApplicantSignedValues);
      schema = DLMApplicantSignedSchema;    
      if (['DOC','MandatoryDOC'].includes(workflow)) {
        submitFunc = submitDLMPhase_5_4;
      } else if (['DOCEdit','DOCSplit','ROIEdit','ROISplit'].includes(workflow)) {
        submitFunc = submitDLMPhase_3_4;
      } else if (workflow === 'Label1b1') {
        submitFunc = submitDLMPhase_4_5;
      } else if (workflow === 'Label5') {
        submitFunc = submitDLMPhase_3_5;
      } else if (workflow === 'LabelReplacement') {
        submitFunc = submitDLMPhase_4_4;
      } else if (workflow === 'MandatoryDOC1B') {
        submitFunc = submitDLMPhase_6_4;
      }

      break;

    case 'DOC Pending SCDF Verification':
      initValues = cloneDeep(initVerifyDOCValues);  
      schema = DLMVerifyDOCSchema;          
      if (['DOC','MandatoryDOC'].includes(workflow)) {
        submitFunc = submitDLMPhase_5_2;
      } else if (['DOCEdit','DOCSplit'].includes(workflow)) {
        submitFunc = submitDLMPhase_3_2;
      } else if (workflow === 'MandatoryDOC1B') {
        submitFunc = submitDLMPhase_6_2;
      }
      break;

    case 'Pending Component Check':
      initValues = {
        ...cloneDeep(initDLMComponentCheckValues),
        ...cloneDeep(initBillingDetails),
      };
      schema = DLMComponentCheckSchema;
      if (workflow === 'Label1b2' || workflow === 'Label1b3') {
        submitFunc = submitDLMPhase_2_1;
      }
      hasBillingDetails = true;
      break;

    case 'Testing in Progress':    
      initValues = {
        ...cloneDeep(initDLMTestResultValues),
        ...cloneDeep(initBillingDetails),
      };
      schema = DLMTestResultSchema;            
      if (workflow === 'TriggerTest') {
        submitFunc = submitDLMPhase_3_3;
      }
      break;

    case 'Site Inspection Review':
      initValues = cloneDeep(initDLMPhaseNoteValues);
      schema = DLMPhaseNoteSchema;
      if (workflow === 'SiteInspect' || workflow === 'LabelInspect' || workflow === 'MandatoryDOC' || workflow === 'Label1b1' || workflow === 'LabelReplacement') {        
        submitFunc = submitDLMPhase_3_1;        
      } else if (workflow === 'Label5') {
        submitFunc = submitDLMPhase_6_1;
      } else if (workflow === 'MandatoryDOC1B') {                
        submitFunc = submitDLMPhase_5_4;
      }
      break;

    case 'Site Inspection Approved':
      if (workflow === 'Label1b1' || workflow === 'LabelReplacement') {
        initValues = cloneDeep(initDLMSubmitROIValues);
        schema = DLMSubmitROISchema;
        submitFunc = submitDLMPhase_4_1;
      } else if (workflow === 'MandatoryDOC1B') {
        initValues = cloneDeep(initDLMSubmitDOCValues);
        schema = DLMSubmitDOCSchema;
        submitFunc = submitDLMPhase_6_1;
      }
      break;

    case 'Inspection Setup':
      if (workflow === 'Label1b1') {
        // Phase 3_1
        initValues = {
          ...cloneDeep(initDLMTestResultValues),
          ...cloneDeep(initBillingDetails),
        };
        schema = DLMTestResultSchema;
        submitFunc = submitDLMPhase_3_1;        
        hasBillingDetails = true;
      } else if (workflow === 'Label5') {
        // Phase 5_1
        initValues = cloneDeep(initDLMSetupInspectionValues);
        schema = DLMSetupInspectionSchema;
        submitFunc = submitDLMPhase_5_1;
      }
      break;

    case 'Component Check - Admin Setup':
      // Label1b2, Label1b3 : Phase 2_4
      initValues = cloneDeep(initDLMSetupInspectionValues);
      schema = DLMSetupInspectionSchema;
      submitFunc = submitDLMPhase_2_4;
      break

    case 'ROI Pending SCDF Verification':
      initValues = cloneDeep(initDLMSubmitROIValues);
      schema = DLMSubmitROISchema;
      if (workflow === 'Label1b1' || workflow === 'LabelReplacement') {
        submitFunc = submitDLMPhase_4_2;
      } else if (workflow === 'Label5' || workflow === 'ROIEdit' || workflow === 'ROISplit') {
      // Phase 3_2
        submitFunc = submitDLMPhase_3_2;
      }
      break;

    case 'Inspector Reviewer':
      if (workflow === 'DOC') {
        // Phase 3_1
        initValues = {
          ...cloneDeep(initDLMTestResultValues),
          ...cloneDeep(initBillingDetails),
        };
        schema = DLMTestResultSchema;
        submitFunc = submitDLMPhase_3_1;        
        hasBillingDetails = true;
      } else if (workflow === 'Label1b1') {
        // Phase 4_1
        initValues = cloneDeep(initDLMPhaseNoteValues);
        schema = DLMPhaseNoteSchema;
        submitFunc = submitDLMPhase_4_1;      
      } else  if (workflow === 'Label5') {
        // Phase 6_1
        initValues = cloneDeep(initDLMPhaseNoteValues);
        schema = DLMPhaseNoteSchema;
        submitFunc = submitDLMPhase_6_1;      
      }
      break;

    case 'Program Manager Approval - Admin Setup':
      if (workflow === 'MandatoryDOC') {
        // Phase 4_1
        initValues = cloneDeep(initDLMProgramManagerSetupValues);
        schema = DLMProgramManagerSetupSchema;
        submitFunc = submitDLMPhase_4_1;
      }
      break;

    case 'Batch Testing':  // MandatoryDOC1B        
      initValues = {
        ...cloneDeep(initDLMSelectReviewerValues),
        ...cloneDeep(initBillingDetails),
      };
      schema = DLMSelectReviewerSchema;                            
      hasBillingDetails = true;
      if (workflow === 'MandatoryDOC1B') {                        
          submitFunc = submitDLMPhase_2_1;            
      }
      break;

    case 'Sampling':        
      initValues = {
        ...cloneDeep(initDLMTravelNoteValues),
        ...cloneDeep(initBillingDetails),
      };
      schema = DLMTravelNoteSchema;                            
      hasBillingDetails = true;
      if (workflow === 'MandatoryDOC1B') {        
        submitFunc = submitDLMPhase_3_1;
      }
      if (workflow === 'TriggerTest') { 
        submitFunc = submitDLMPhase_3_2;
      }       
      break;
      
    case 'Testing':  
      initValues = {
        ...cloneDeep(initDLMTravelNoteValues),
        ...cloneDeep(initBillingDetails),
      };
      schema = DLMTravelNoteSchema;                            
      hasBillingDetails = true;
      if (workflow === 'MandatoryDOC1B') {              
        submitFunc = submitDLMPhase_4_1;
      }
      break;      
    
    case 'Batch Testing Setup':
    case 'Sampling Setup':
    case 'Testing Setup':
    case 'Site Inspection Setup': 
      if (workflow === 'MandatoryDOC1B') {
        initValues = cloneDeep(initDLMSetupInspectionValues);
        schema = DLMSetupInspectionSchema;        
        switch (appState) {
          case 'Batch Testing Setup':  // MandatoryDOC1B        
            submitFunc = submitDLMPhase_2_4;
            break;
          case 'Sampling Setup':        
            submitFunc = submitDLMPhase_3_4;
            break;
          case 'Testing Setup':  
            submitFunc = submitDLMPhase_4_4;
            break;
          case 'Site Inspection Setup': 
            submitFunc = submitDLMPhase_5_1;
            break;
          default: 
            break;
        }
      }
      break;
    case 'Draft Quotation': 
      if (workflow === 'TriggerTest') {
        initValues = cloneDeep(initDLMQuotationUploadValues);
        // upload existing quotations
        if (quotations && isPopulatedArray(quotations)) {
          Object.assign(initValues, {
              quotations: quotations.map( o => ({
                  quotationAttachmentId: o.quotationAttachment.id,
                  quotationAttachmentName: o.quotationAttachment.fileName,
                  quotationNumber: o.quotationNumber,
              }))
          })
        }
        schema = DLMQuotationUploadSchema;                
        submitFunc = submitDLMPhase_2_1; 
      }
      break;    

    case 'Quotation Approved': 
      if (workflow === 'TriggerTest') {
        initValues = cloneDeep(initDLMPhaseNoteValues);
        schema = DLMPhaseNoteSchema;
        submitFunc = submitDLMPhase_2_3; 
      }
      break;    
    
    default:
      break;
  }

  if (initValues && workflow) {
    Object.assign(initValues, {workflow, appState});
  
    if (docModels && ['DOC','MandatoryDOC','DOCEdit','DOCSplit','MandatoryDOC1B'].includes(workflow)) {
      Object.assign(initValues, {docModels});
    }
    if (siteROIModels && ['Label5','Label1b1','Label1b2','Label1b3','ROIEdit','ROISplit','LabelReplacement'].includes(workflow)) {
      Object.assign(initValues, {siteROIModels});
    }
  }

  return { initValues, schema, submitFunc, hasBillingDetails};
}


export {getUserResponseVars};
